// extracted by mini-css-extract-plugin
module.exports = {"content":"EventFAQs_content__g6_UB","title":"EventFAQs_title__DUg6z"};